(() => {
  const pageType = document.currentScript?.dataset?.pageType || '';
  if (pageType !== 'index') return;

  const removeRedundantShippingBanner = () => {
    for (const section of document.querySelectorAll('.shopify-section--apps')) {
      if (/Versicherter Versand mit DHL/i.test(section.textContent || '')) {
        section.style.display = 'none';
        section.dataset.gs2RedundantBanner = 'hidden';
        return true;
      }
    }
    return false;
  };

  const labelInstagram = () => {
    if (document.querySelector('.gs-instagram-heading')) return true;

    for (const section of document.querySelectorAll('.shopify-section--apps')) {
      const hasInstafeed = section.querySelector('[id*="insta" i], [class*="insta" i], iframe[src*="insta" i], iframe[src*="instagram" i]');
      if (!hasInstafeed) continue;

      const header = document.createElement('div');
      header.className = 'gs-instagram-heading';
      header.innerHTML = '<p class="gs-instagram-heading__eyebrow">Goldstück auf Instagram</p><h2 class="gs-instagram-heading__title">Mehr Goldstück. Jeden Tag. ♡</h2><p class="gs-instagram-heading__copy">Neue Looks, Lives, Styling-Ideen und alles, was gerade bei uns im Store passiert.</p><a class="gs-instagram-heading__link" href="https://www.instagram.com/goldstueck_schwabach/" target="_blank" rel="noopener">@goldstueck_schwabach folgen</a>';
      section.insertAdjacentElement('beforebegin', header);
      return true;
    }
    return false;
  };

  const polish = () => {
    removeRedundantShippingBanner();
    labelInstagram();
  };

  polish();

  let attempts = 0;
  const observer = new MutationObserver(() => {
    polish();
    attempts += 1;
    if (attempts > 25 || (document.querySelector('.gs-instagram-heading') && document.querySelector('[data-gs2-redundant-banner="hidden"]'))) observer.disconnect();
  });
  observer.observe(document.body,{childList:true,subtree:true});
  window.setTimeout(() => observer.disconnect(),8000);
})();
